var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.hour)+":"+_vm._s(_vm.min)+":"+_vm._s(_vm.sec))]},{"hour":_vm.hour,"min":_vm.min,"sec":_vm.sec})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }